import i18n from 'i18next'

/** Translate outside React render (e.g. mutation onSuccess toasts). */
export function translate(key: string, options?: Record<string, unknown>): string {
  return String(i18n.t(key, options as never))
}
